export const FINDING_STATE_LABELS: Record<string, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Undetected',
};
